/* eslint-disable prettier/prettier */
/**
 * Codes for questionnaire questions and answers (CJT-15710): Salesforce field -> question code, Salesforce answer value -> number.
 * Plain JSON on purpose (same convention as trackingDimensionsMapping.ts). Keep it JSON.
 */
import { QuestionnaireCodesMapping } from '../interface/IQuestionnaireCodesMapping';

const mapping: QuestionnaireCodesMapping = {
  "_about": "Codes for questionnaire questions and answers (CJT-15710). Generated from opex-work posthog/questionnaire-answers/mapping.json (build_mapping.py); the decode table lives there. Codes are never reused.",
  "version": "2026-10-02",
  "unmapped_code": -1,
  "unmapped_question_code": "Q??",
  "fields": {
    "Type_of_treatment__c": {
      "code": "Q01",
      "values": {
        "Followup care": 1,
        "First care": 0
      }
    },
    "Prescription__c": {
      "code": "Q02",
      "values": {
        "Available": 1,
        "Not available": 0
      }
    },
    "Current_hearing_test__c": {
      "code": "Q03",
      "values": {
        "Yes": 1,
        "No": 0
      }
    },
    "Testing_Fields_3__c": {
      "code": "Q04",
      "values": {
        "Testanswer 1": 1,
        "Testanswer 2": 0
      }
    },
    "Testing_Fields_8__c": {
      "code": "Q05",
      "values": {
        "Testanswer 1": 1,
        "Testanswer 2": 0
      }
    },
    "Why_not_sooner__c": {
      "code": "Q06",
      "values": {
        "been too busy": 1,
        "cannot afford them": 2,
        "not sure if needed": 3
      }
    },
    "Degree_of_suffering__c": {
      "code": "Q07",
      "values": {
        "Not at all": 1,
        "Barely": 2,
        "Severely": 3
      }
    },
    "Testing_Fields_17__c": {
      "code": "Q08",
      "values": {
        "Testanswer 1": 1,
        "Testanswer 2": 0
      }
    },
    "Age_of_current_hearing_aid__c": {
      "code": "Q09",
      "values": {
        "1": 1,
        "2": 2,
        "3": 3,
        "4": 4,
        "5": 5,
        "6": 6
      }
    },
    "Ear_Molds_used__c": {
      "code": "Q10",
      "values": {
        "Yes": 1,
        "No": 0,
        "Unknown": 9
      }
    },
    "Worn_regularely_advanced__c": {
      "code": "Q11",
      "values": {
        "Yes, every day": 3,
        "Only on special occasions": 2,
        "No, they reside in the drawer": 1,
        "Testanswer 1": 3,
        "Testanswer 2": 2,
        "Testanswer 3": 1,
        "Testanswer 4": 0
      }
    },
    "Satisfaction_current_device__c": {
      "code": "Q12",
      "values": {
        "Not satisfied": 1,
        "I don't know": 2,
        "Satisfied": 3,
        "Very satisfied": 4
      }
    },
    "Testing_Fields_19__c": {
      "code": "Q13",
      "values": {
        "Testanswer 4": 1,
        "Testanswer 3": 2,
        "Testanswer 2": 3,
        "Testanswer 1": 4
      }
    },
    "Willing_to_invest__c": {
      "code": "Q14",
      "values": {
        "Yes": 1,
        "No": 0
      }
    },
    "Purchase_timeframe__c": {
      "code": "Q15",
      "values": {
        "asap": 1,
        "months": 2,
        "unknown": 9
      }
    },
    "What_is_most_important__c": {
      "code": "Q16",
      "values": {
        "Best value for my budget": 1,
        "Latest high-end technology": 2,
        "Premium service": 3
      }
    },
    "Testing_Fields_12__c": {
      "code": "Q17",
      "values": {
        "Testanswer 4": 0,
        "Testanswer 3": 1,
        "Testanswer 2": 2,
        "Testanswer 1": 3
      }
    },
    "Professional_Status__c": {
      "code": "Q18",
      "values": {
        "Employed": 1,
        "Self-employed": 2,
        "Retired": 3
      }
    },
    "Insurance_type__c": {
      "code": "Q19",
      "values": {
        "statutory": 1,
        "private": 2
      }
    },
    "Insurance_Company__c": {
      "code": "Q20",
      "values": {
        "AOK": 1,
        "Barmer": 2,
        "BKK": 3,
        "DAK": 4,
        "HKK": 5,
        "IKK": 6,
        "KKH": 7,
        "Knappschaft": 8,
        "SVLFG": 9,
        "Techniker": 10,
        "Allianz": 21,
        "AXA": 22,
        "Barmenia": 23,
        "Bayerische Beamtenkrankenkasse": 24,
        "Debeka": 25,
        "DKV": 26,
        "Generali": 27,
        "Gothaer": 28,
        "Hallesche": 29,
        "Münchener Verein": 30,
        "Signal": 31,
        "Versicherungskammer Bayern (VKB)": 32,
        "Württembergische": 33,
        "Andere": 99
      }
    },
    "Testing_Fields_13__c": {
      "code": "Q21",
      "values": {
        "Testanswer 1": 1,
        "Testanswer 2": 0
      }
    },
    "Testing_Fields_7__c": {
      "code": "Q22",
      "values": {
        "Testanswer 1": 1,
        "Testanswer 2": 0
      }
    },
    "whatsapp_consent__m": {
      "code": "Q23",
      "values": {
        "consent provided": 1,
        "consent declined": 0
      }
    },
    "Express_written_consent__c": {
      "code": "Q24",
      "values": {
        "consent provided": 1,
        "consent declined": 0,
        "not set": 9
      }
    },
    "Preferred_appointment_time__c": {
      "code": "Q25",
      "values": {
        "Between 9AM and 11AM": 1,
        "Between 11AM and 1PM": 2,
        "Between 2PM and 4PM": 3,
        "Between 4PM and 6PM": 4,
        "Prefer to schedule appointment in the call": 9
      }
    },
    "qbht_question_1__c": {
      "code": "Q26",
      "values": {
        "Completely disagree": 1,
        "Rather disagree": 2,
        "Rather agree": 3,
        "Completely agree": 4
      }
    },
    "qbht_question_2__c": {
      "code": "Q27",
      "values": {
        "Completely disagree": 1,
        "Rather disagree": 2,
        "Rather agree": 3,
        "Completely agree": 4
      }
    },
    "qbht_question_3__c": {
      "code": "Q28",
      "values": {
        "Completely disagree": 1,
        "Rather disagree": 2,
        "Rather agree": 3,
        "Completely agree": 4
      }
    },
    "qbht_question_4__c": {
      "code": "Q29",
      "values": {
        "Completely disagree": 1,
        "Rather disagree": 2,
        "Rather agree": 3,
        "Completely agree": 4
      }
    },
    "qbht_question_5__c": {
      "code": "Q30",
      "values": {
        "Completely disagree": 1,
        "Rather disagree": 2,
        "Rather agree": 3,
        "Completely agree": 4
      }
    },
    "Testing_Fields_20__c": {
      "code": "Q31",
      "values": {
        "Testanswer 1": 1,
        "Testanswer 2": 2,
        "Testanswer 3": 3,
        "Testanswer 4": 4,
        "Testanswer 5": 5
      }
    },
    "Consultation_goal__c": {
      "code": "Q32",
      "values": {
        "Hearing aids trial": 1,
        "Information only": 2,
        "Lost hearing aids replacement": 3
      }
    },
    "Testing_Fields_1__c": {
      "code": "Q33",
      "values": {
        "Testanswer 1": 1,
        "Testanswer 2": 0
      }
    },
    "Testing_Fields_5__c": {
      "code": "Q34",
      "values": {
        "Testanswer 1": 1,
        "Testanswer 2": 2,
        "Testanswer 3": 3,
        "Testanswer 4": 4,
        "Testanswer 5": 5
      }
    }
  }
};

export default mapping;
